import type { CSSProperties } from 'react';

const ROWS: [string, string][] = [
  ['W A S D', 'move on ground'],
  ['Q / E', 'down / up'],
  ['↑ ↓ ← →', 'rotate view'],
  [', / .', 'prev / next frame'],
  ['drag · scroll', 'orbit · zoom'],
];

/** Small, unobtrusive legend of the keyboard/mouse controls (usability aid). */
export function ControlsHint() {
  return (
    <div className="controls-hint" style={panel}>
      {ROWS.map(([keys, desc]) => (
        <div key={keys} style={row}>
          <kbd style={kbd}>{keys}</kbd>
          <span style={{ opacity: 0.7 }}>{desc}</span>
        </div>
      ))}
    </div>
  );
}

const panel: CSSProperties = {
  position: 'fixed',
  left: 16,
  bottom: 20,
  padding: '9px 11px',
  borderRadius: 8,
  background: 'rgba(12,16,22,0.6)',
  border: '1px solid rgba(255,255,255,0.07)',
  color: '#e6edf3',
  font: '11px/1.5 system-ui, sans-serif',
  userSelect: 'none',
  pointerEvents: 'none',
};

const row: CSSProperties = { display: 'flex', alignItems: 'center', gap: 8 };

const kbd: CSSProperties = {
  display: 'inline-block',
  minWidth: 78,
  padding: '1px 6px',
  borderRadius: 4,
  background: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.12)',
  fontFamily: 'ui-monospace, monospace',
  fontSize: 10.5,
  textAlign: 'center',
};
